import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/leaderboard-up.svg'
import _imports_1 from '@/assets/img/Icons/leaderboard-down.svg'
import _imports_2 from '@/assets/img/Icons/trophy.svg'


const _withScopeId = n => (_pushScopeId("data-v-454ddb7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nps-block" }
const _hoisted_2 = { class: "nps" }
const _hoisted_3 = {
  key: 0,
  class: "change"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = { class: "number" }
const _hoisted_7 = {
  key: 0,
  class: "rank-block"
}
const _hoisted_8 = { class: "rank-number" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "trophy"
}, null, -1))
const _hoisted_10 = { class: "rank-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'nps-number': true,
            'has-rank': _ctx.showRank,
        })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.getNpsRounded(_ctx.tsNpsSummary.nps)), 1),
      (!_ctx.tsNpsSummary.isFiveScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.tsNpsSummary.change >= 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.getNpsRounded(_ctx.tsNpsSummary.change)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showRank)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.tsNpsSummary.rank) + _toDisplayString(_ctx.getOrdinalRank(_ctx.tsNpsSummary.rank)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, "in " + _toDisplayString(_ctx.tsNpsSummary.rankFieldLabel), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}